import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type ChildLeaveSummaryResponse} from './child-leave-summary-data';

export function childLeaveSummaryTypePatcher(
    data: ChildLeaveSummaryResponse,
): RestTypeWithTypename<ChildLeaveSummaryResponse> {
    return {
        __typename: 'ChildLeaveSummaryData',
        leaves: data.leaves.map(l => l.map(ll => ({__typename: 'Leaves', ...ll}))),
        months: data.months.map(m => ({__typename: 'Months', ...m})),
        past: {
            __typename: 'Past',
            ...data.past,
        },
        period: {
            __typename: 'Period',
            ...data.period,
        },
        totals: {
            __typename: 'Totals',
            ...data.totals,
        },
    };
}
